import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd044aService,
  Sgkd044aRequest,
  Sgkd044aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkd044aService {

  private _rsesult$ = new Subject<Sgkd044aResponse>();

  constructor(private sgkd044aService: Sgkd044aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * クレジット企業コード取得API呼び出し
   * 
   * @param claimCtrNo 請求お客さま番号
   * @param date 日付
   * @memberof UsedSgkd002dSgkd044aService
   */
  doSgkd044a(): Observable<Sgkd044aResponse> {

    // リクエスト生成
    let request: Sgkd044aRequest = {};

    return this.sgkd044aService.doSGKD044APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
          //return true;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD044A');
          return throwError(err.message);
        }
      )
    );
  }
}
